<script setup lang="ts">
import { z } from 'zod'

type Props = {
  onSuccess?: () => void | Promise<unknown>
}

const props = defineProps<Props>()

const auth = useAuthStore()
const modals = useModalsStore()

const schema = toTypedSchema(
  z.object({
    email: z.string().email(),
    password: z.string().min(1),
  }),
)

const { errors, defineField, handleSubmit, isSubmitting } = useForm({
  validationSchema: schema,
})

const [email, emailAttrs] = defineField('email')
const [password, passwordAttrs] = defineField('password')

const onSubmit = handleSubmit(async (values) => {
  try {
    await auth.login(values)

    await props.onSuccess?.()
  } catch (error) {
    // console.error(error)
  }
})

const resetPassword = () => {
  modals.openForgotPasswordModal()

  if (modals.isLoginModalOpen) {
    modals.closeLoginModal()
  }
}
</script>

<template>
  <form @submit="onSubmit">
    <AppTextField
      v-model="email"
      v-bind="emailAttrs"
      :error="!!errors.email"
      class="mb-3 md:mb-4"
      type="email"
      :placeholder="$t('string.Email-address')"
      full-width
    />

    <AppTextField
      v-model="password"
      v-bind="passwordAttrs"
      :error="!!errors.password"
      class="mb-3 md:mb-4"
      type="password"
      :placeholder="$t('string.Password')"
      full-width
    />

    <div class="mb-8 flex items-center justify-between">
      <div></div>

      <AppButton variant="text" @click="resetPassword">
        {{ $t('string.Forgot-password') }}
      </AppButton>
    </div>

    <AppButton type="submit" full-width :loading="isSubmitting">
      {{ $t('string.Login') }}
    </AppButton>
  </form>
</template>

<style lang="scss">
@import '@boats/ui/styles/config';
</style>
